// Import the Phosphor icons plugin
import PhosphorIcons from '@phosphor-icons/vue'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.vueApp.use(PhosphorIcons)
})
